<template>
  <div class="dgs grid-gua paper-grain" data-product="career">
    <div class="sheet">
      <div class="auth-hero">
        <div class="seal">喵</div>
        <div class="name">喵星君大大新用户注册</div>
        <div class="sub">排盘需要你的出生信息，请如实填写</div>
      </div>

      <div class="card mt-4">
        <div class="card-title"><span class="dot"></span>基本信息</div>

        <div class="field">
          <label>性别</label>
          <div class="segment">
            <div class="seg" :class="{ active: sex === '男' }" @click="sex = '男'">男生</div>
            <div class="seg" :class="{ active: sex === '女' }" @click="sex = '女'">女生</div>
          </div>
        </div>

        <div class="field">
          <label>出生时间</label>
          <div class="pick-row" @click="showPicker2 = true">
            <input class="control readonly" :value="datetime" placeholder="点击选择出生时间" readonly>
            <div class="arr">⌄</div>
          </div>
        </div>
        <van-popup v-model="showPicker2" position="bottom">
          <van-datetime-picker
            type="datetime"
            v-model="currentDate"
            title="选择完整时间"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="onConfirmTime"
            @cancel="showPicker2 = false"
          />
        </van-popup>

        <div class="field">
          <label>出生地（用于真太阳时校正）</label>
          <div class="pick-row" @click="showArea = true">
            <input class="control readonly" :value="provincecity" placeholder="点击选择出生地" readonly>
            <div class="arr">⌄</div>
          </div>
        </div>
        <van-popup v-model="showArea" position="bottom">
          <van-area
            :area-list="areaList"
            :columns-num="2"
            @confirm="onConfirmCity"
            @cancel="showArea = false"
          />
        </van-popup>

        <div class="form-hint">
          <b>说明：</b>不确定出生时间将默认为 00:00；<br>
          出生地影响真太阳时，请尽量精确到区县。
        </div>
      </div>

      <van-button
        :loading="loading"
        loading-text="请求中..."
        class="btn btn-seal btn-block mt-4"
        @click="onSubmit"
      >提交</van-button>
      <van-button
        class="btn btn-ghost btn-block mt-2"
        @click="$router.go(-1)"
      >暂不填写</van-button>

      <div class="foot">注：7天内只可修改一次资料</div>
    </div>
  </div>
</template>
<script>
import { areaList } from '@vant/area-data';
import { Toast } from 'vant';
import {postAction} from '@/api/manage'
import { Dialog } from 'vant';
export default {
  name: 'success',
  data() {
    return {
      username: '',
      sex:'',
      password: '',
      provincecity:'',
      showArea: false,
      areaList, // 数据格式见 Area 组件文档
      datetime: '',
      showPicker: false,
      showPicker2: false,
      minDate: new Date(1960, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(1990, 0, 1),
      sex: '女',
      loading:false,
      userInfo:{}
   };
  },
  computed:{
    userinfoLove() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.$store.getters.getUserinfoLove || {};
    },
    openid() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.userinfoLove.jsopenid;
    },
    unionid() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.userinfoLove.unionid;
    },
    headimg() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.userinfoLove.image;
    },
    name() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.userinfoLove.nickname;
    },
    code(){
      return this.$route.query.code ? this.$route.query.code : ''
    },
  },
  mounted(){
    if(!this.unionid){
      if(!this.code){
        var url = encodeURIComponent(window.location.protocol+"//"+window.location.hostname+ '/userRegister')
        window.location.href=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbb2af162829dc7fe&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
      } else {
         this.getJsLogin()
      }
    }
  },
  methods:{
        onSubmit(){
            if(this.datetime == '' || this.provincecity == ''){
            Toast.fail('输入不能为空');
            return
            }
            let url = '/user/register'
            const city = this.provincecity.split('/')
            const dateList = this.datetime.split(' ')
            const params = {
            unionid: this.unionid,
            jsopenid: this.openid,
            image: this.headimg,
            nickname: this.name,
            sex: this.sex,
            province: city[0],
            city: city[1],
            date: dateList[0],
            time: dateList[1]
            }
            this.loading = true
            postAction(url,params)
            .then((res) => {
                if(res.data.code === 200){
                    Toast.success('注册成功');
                    this.userInfo = res.data.msg
                    this.$store.commit('setUserInfoLove', this.userInfo)
                    Dialog.alert({
                      message: `注册成功，您的编号为${this.userInfo.id}`,
                      theme: 'round-button',
                    }).then(() => {
                      // on close
                    });
                    // this.$router.push({ path: '/dailyluck'})
                }else{
                    Toast.fail(res.data.msg);
                }
            })
            .finally((res) => {
                this.loading = false
            })
        },
        getJsLogin(){
            const url = '/xcxlove/double/jslogin'
            // const url = '/user/test'
                postAction(url, {code:this.code}).then( res => {
                  if(res.data.code == 200 || res.data.code == 400){
                      this.userInfo = res.data.msg
                      this.$store.commit('setUserInfoLove', this.userInfo)
                  }
                })
        },
        onConfirmCity(values) {
            this.provincecity = values
            .filter((item) => !!item)
            .map((item) => item.name)
            .join('/');
            console.log('values',this.provincecity)
            this.showArea = false;
        },
        onConfirmTime(time) {
            console.log('values',time)
            this.datetime = this.parseTime(time,'{y}-{m}-{d} {h}:{i}' )
            console.log('values',this.datetime)
            this.showPicker2 = false;
        },
        parseTime (time, cFormat) {
            if (arguments.length === 0) {
            return null
            }
            if (!time) return ''
            const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
            let date
            if (typeof time === 'object') {
            date = time
            } else {
            if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
                time = parseInt(time)
            }
            if ((typeof time === 'number') && (time.toString().length === 10)) {
                time = time * 1000
            }
            date = new Date(time)
            }
            const formatObj = {
            y: date.getFullYear(),
            m: date.getMonth() + 1,
            d: date.getDate(),
            h: date.getHours(),
            i: date.getMinutes(),
            s: date.getSeconds(),
            a: date.getDay()
            }
            const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
            let value = formatObj[key]
            // Note: getDay() returns 0 on Sunday
            if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
            if (result.length > 0 && value < 10) {
                value = '0' + value
            }
            return value || 0
            })
            return timeStr
        }
  }
}
</script>
<style scoped>
@import "../style/design-system.css";

.auth-hero { padding-top: 48px; text-align: center; }
.auth-hero .seal { width: 54px; height: 54px; font-size: 22px; margin: 0 auto 14px; }
.auth-hero .name { font-family: var(--f-serif); font-size: 24px; letter-spacing: .16em; color: var(--ink); }
.auth-hero .sub { margin-top: 8px; font-size: 13px; color: var(--ink-mute); }

.pick-row { cursor: pointer; }
.pick-row .control.readonly { background: rgba(27,25,22,.04); color: var(--ink-mute); cursor: pointer; }
.pick-row .control.readonly::placeholder { color: var(--ink-faint); }

.foot { margin-top: 28px; text-align: center; color: var(--ink-mute); font-size: 12px; letter-spacing: .04em; }

::v-deep .van-button { font-family: var(--f-sans); }
</style>
